export const ENV_CONFIG_PRIVATE_KEY = "__ENV_CONFIG_PRIVATE__";
export const ENV_CONFIG_PUBLIC_KEY = "__ENV_CONFIG_PUBLIC__";
/**
 * Initialises the Private Environment Config with the provided `config`.
 * The config object is added to the globalTarget scope and frozen to prevent accidental mutation.
 */
export function initialisePrivateEnvConfig(config, globalTarget) {
    if (typeof window !== "undefined")
        throw new Error("Cannot initialise private environment config in the browser.");
    // Idempotent: only initialise once.
    if (ENV_CONFIG_PRIVATE_KEY in globalTarget)
        return;
    // Object is frozen to prevent accidental mutation.
    Object.defineProperty(globalTarget, ENV_CONFIG_PRIVATE_KEY, {
        value: Object.freeze({ ...config }),
        enumerable: true,
        configurable: false,
    });
}
/**
 * Initialises the Public Environment Config with the provided `config`.
 * The config object is added to the globalTarget scope and frozen to prevent accidental mutation.
 */
export function initialisePublicEnvConfig(config, globalTarget) {
    // Idempotent: only initialise once.
    if (ENV_CONFIG_PUBLIC_KEY in globalTarget)
        return;
    // Cleanse the config of any private keys (i.e. keep only keys with `_PUBLIC` suffix).
    const cleansedConfig = Object.fromEntries(Object.entries(config).filter(([key]) => key.endsWith("_PUBLIC")));
    // Object is frozen to prevent accidental mutation.
    Object.defineProperty(globalTarget, ENV_CONFIG_PUBLIC_KEY, {
        value: Object.freeze(cleansedConfig),
        enumerable: true,
        configurable: false,
    });
}
//# sourceMappingURL=store.js.map